import { __extends } from "tslib";
import { deserializeAws_restXmlHeadObjectCommand, serializeAws_restXmlHeadObjectCommand } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { getSsecPlugin } from "@aws-sdk/middleware-ssec";
import { Command as $Command } from "@aws-sdk/smithy-client";
var HeadObjectCommand = /** @class */ (function (_super) {
    __extends(HeadObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function HeadObjectCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    HeadObjectCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getSsecPlugin(configuration));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    HeadObjectCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlHeadObjectCommand(input, context);
    };
    HeadObjectCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlHeadObjectCommand(output, context);
    };
    return HeadObjectCommand;
}($Command));
export { HeadObjectCommand };
//# sourceMappingURL=HeadObjectCommand.js.map